export default "__VITE_ASSET__CAwFqTvY__"